import React, { createContext, useContext } from 'react';

// eslint-disable-next-line no-console
const SendErrorContext = createContext(console.error);

export const SendErrorProvider = ({
  value,
  children,
}: {
  value: HandleError;
  children: JSX.Element;
}): JSX.Element => (
  <SendErrorContext.Provider value={value}>
    {children}
  </SendErrorContext.Provider>
);

/**
 * @deprecated Use `sendError` prop instead. This hook will be removed in a future version.
 */
export const useSendError = (): HandleError => useContext(SendErrorContext);

export type HandleErrorType = HandleError;
